import * as React from 'react';
import { Box, Link } from '@mui/material';
import { PAGE } from '../../../constants/page';

interface Props {
  children?: React.ReactElement<unknown>;
  color?: 'light' | 'dark'
}

export default function Logo(props: Props) {
  return (
    <Box>
      <Link sx={{ display: 'inline-block' }} href={PAGE.TOP.PATH}>
        <Box sx={{
          padding: '10px',
          whiteSpace: 'nowrap'
        }}>
          <Box
            component="img"
            sx={{ height: 50 }}
            src={props.color === 'dark' ? '/assets/icons/logo_suprime_dark.svg' : '/assets/icons/logo_suprime_light.svg'}
          />
        </Box>
      </Link>
    </Box >
  );
}